import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { CopiaContratoService } from '../services/copiacontrato.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';

declare let $: any;

@Component({
  selector: 'app-login-modal-invalido',
  templateUrl: './login-modal-invalido.html',
  styleUrls: ['./login.component.css'],
  providers: [CopiaContratoService, MensagemService, RestClientService],
})
export class LoginModalInvalidoComponent
  extends AbstractComponent
  implements OnInit
{
  status: string = '';

  constructor(
    private sessaoService: SessaoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LoginModalInvalidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(sessaoService);
  }

  /**
   * Método chamado quando o componente é incializado
   */
  ngOnInit() {}

  ok() {
    this.fechar();
  }

  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/login/login-modal-invalido.ts